import script from "./RouteDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./RouteDetails.vue?vue&type=script&setup=true&lang=js"

import "./RouteDetails.vue?vue&type=style&index=0&id=155789e2&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-155789e2"]])

export default __exports__